export function ProgressBar({ value = 0, tone = 'info', label }) {
  const width = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <div className="progress-block">
      {label ? <div className="progress-block-label">{label}</div> : null}
      <div className="progress-track" role="progressbar" aria-valuenow={width} aria-valuemin={0} aria-valuemax={100}>
        <div className={`progress-fill progress-fill--${tone}`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
